export default "__VITE_ASSET__lAA5Pzwk__"